<template>
  <div class="container">
    <div class="my_car">
      <div class="my_car__hb">
        <div class="header" :style="{
            backgroundImage:
              'url(' +
              require('@/assets/payment-related/Blp_cardbg@2x.png') +
              ')'
          }">
          <div class="header__info" v-if="isDefult">
            <span class="header__info__title">{{ defultCarinfo.cardNumber }}
            </span>
            <span class="header__info__content">您的默认车牌</span>
          </div>
          <div class="header__unavailable" v-if="!isDefult">
            <span class="header__unavailable__title">未设置默认车牌</span>
            <span class="header__unavailable__content">可选择历史绑定车牌设置</span>
          </div>
          <div class="header__untied-btn" v-if="isDefult">
            <van-button style="padding:10px" color="#f5f6fa" size="small" plain round
              @click="deleteCarAndUserRel(defultCarinfo.id)">
              解&nbsp;绑
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <div class="data_list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="handleFilter">
        <van-cell size="large" v-for="(item, index) in dataList" :key="index">
          <span slot="title">
            <van-row>
              <van-col span="6">{{ item.cardNumber }}</van-col>
              <van-col span="6" offset="12">
                <van-button style="padding:15px" type="info" size="small" @click="handleRowEdit(item)">
                  编&nbsp;辑
                </van-button>
              </van-col>
            </van-row>
          </span>
        </van-cell>
      </van-list>
    </div>
    <div class="btn_box bottom">
      <van-button to="bind-car" size="large" class="blue-btn">
        新增车牌
      </van-button>
    </div>
    <van-popup v-model="editShow" closeable round position="bottom" class="bottom_popup_box">
      <div class="bottom_popup_box_menu">
        <div class="btn_box">
          <van-button size="large" class="blue-btn" @click="updateCarAndUserRel">
            设为默认
          </van-button>
        </div>
        <div class="btn_box">
          <van-button size="large" plain class="blue-btn" @click="deleteCarAndUserRel()">
            解绑车牌
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { List, Popup, Row, Col } from 'vant'
import { deleteCarAndUserRel, selectCarAndUserRel, updateCarAndUserRel } from '@/api/park'
import { deepClone } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'My-Car',
  components: {
    [List.name]: List,
    [Popup.name]: Popup,
    [Row.name]: Row,
    [Col.name]: Col
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'zfb_userInfo', 'token']),
    isDefult () {
      if (this.defultCarinfo) {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      editShow: false,
      dataList: [],
      loading: false,
      finished: false,
      defultCarinfo: null,
      tempData: null
    }
  },
  methods: {
    handleFilter () {
      let _this = this
      let params = {
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo.userId
      }
      selectCarAndUserRel(params)
        .then(response => {
          let resData = response.body
          let data = []
          for (let index = 0; index < resData.length; index++) {
            const element = resData[index]
            if (element.isDefaultCar) {
              _this.defultCarinfo = deepClone(element)
            } else {
              data.push(element)
            }
          }
          _this.dataList = deepClone(data)
          // 加载状态结束
          _this.loading = false
          // 数据全部加载完成
          _this.finished = true
        })
        .catch(error => {
          // 加载状态结束
          _this.loading = false
          // 数据全部加载完成
          _this.finished = true
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
    handleRowEdit (row) {
      this.tempData = deepClone(row)
      this.editShow = true
    },
    // 删除车牌用户绑定关系
    deleteCarAndUserRel (id) {
      let _this = this
      let relId = id || _this.tempData.id
      if (id) {
        _this.defultCarinfo = null
      }
      let params = {
        id: relId,
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo.userId
      }
      deleteCarAndUserRel(params)
        .then(response => {
          _this.editShow = false
          if (response.status === 1001) {
            _this.$toast('解绑成功')
          } else {
            _this.$toast('解绑失败')
          }
          _this.handleFilter()
        })
        .catch(error => {
          _this.editShow = false
          _this.$toast(error)
        })
    },
    //修改车牌用户绑定关系
    updateCarAndUserRel () {
      let _this = this
      let params = {
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo.userId,
        cardNumber: _this.tempData.cardNumber,
        isDefaultCar: 1
      }
      updateCarAndUserRel(params)
        .then(response => {
          _this.editShow = false
          if (response.status === 1001) {
            _this.$toast('设置成功')
          } else {
            _this.$toast('设置失败')
          }
          _this.handleFilter()
        })
        .catch(error => {
          _this.editShow = false
          _this.$toast(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .my_car {
    &__hb {
      padding: 15px 6.85vw 15px;

      .header {
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        width: 100%;
        height: 20vh;
        min-height: 140px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        &__untied-btn {
          height: 80%;
          width: 33%;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;

          /deep/ .van-button--plain {
            background-color: rgba(0, 0, 0, 0);
          }
        }

        &__unavailable {
          width: 100%;
          text-align: center;

          &__title {
            display: block;
            color: #fff;
            font-size: 26px;
            font-weight: 500;
          }

          &__content {
            display: block;
            font-size: 14px;
            color: #eaf4ff;
          }
        }

        &__info {
          width: 60%;
          height: 50%;
          display: flex;
          flex-direction: colunm;
          flex-wrap: wrap;
          align-items: center;

          span {
            text-align: center;
          }

          &__title {
            width: 100%;
            color: #fff;
            font-size: 26px;
            font-weight: 500;
          }

          &__content {
            width: 100%;
            font-size: 14px;
            color: #eaf4ff;
          }
        }
      }
    }
  }

  .prompt_tips {
    font-size: 18px;
    text-align: center;
  }

  .data_list {
    text-align: center;
    font-family: Source Han Sans CN;
  }

  .bottom_popup_box {
    height: 250px;
    display: flex;
    justify-content: flex-end; //space-evenly
    align-items: center;
    flex-direction: column;

    .bottom_popup_box_menu {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      height: 175px;
    }
  }

  .bottom {
    margin: 20px auto 20px;
  }

  .btn_box {
    width: calc(100vw - 30px);
    max-width: 600px;
  }
}
</style>